
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"28pt","height":"28pt","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M239.8 1.6c-28.6 5.2-54.2 26.2-65.1 53.5-3 7.4-5.7 17.9-5.7 22.1V80h-16.8c-24.2 0-31.4 2.2-42.9 13.3-7.1 6.8-11.9 15.3-14.7 25.8-.9 3.5-12.7 82.9-26.2 176.4C41.3 483.3 42.3 474 48 485.6c3.6 7.5 13.4 17 21.2 20.8 12.3 5.9 1.7 5.6 186.5 5.6 118.9 0 170.8-.3 174.5-1.1 19.9-4.1 36.1-20.7 37.4-38.5.5-5.7-3.8-37.4-24-176.9-13.5-93.5-25.3-172.9-26.2-176.5-3.3-13.6-13.4-27.4-24.3-33.4-8.2-4.4-15-5.6-32.7-5.6-18.2 0-16.7.7-17.9-8.3-.3-2.6-1.7-7.8-2.9-11.5-14.3-41.9-56.1-66.5-99.8-58.6zm31 15.9c19.7 4 38.1 17.2 48.1 34.8 3.2 5.6 7.5 17.9 8.4 23.9l.6 3.8H185v-2.4c0-4.5 4.6-18.1 8.4-24.9 4.6-8.3 14.8-19.3 22.7-24.6 6.9-4.6 19.6-9.7 27.1-11 8.5-1.4 19.3-1.2 27.6.4zm114 81.9c8.2 4.6 14.3 12.8 17.1 23.1 1.4 5.4 50.1 342.7 50.1 347.4 0 4.9-4.3 13.2-8.8 17.2-2 1.8-6.1 4.4-9.2 5.8l-5.5 2.6h-345l-4.9-2.3C68 488.3 60 478.4 60 470.1c0-4.5 48.7-342.3 50.1-347.6 1.4-5.2 5.1-12.4 8.5-16.4 3-3.6 10.1-8 14.7-9.2 1.8-.4 57.9-.6 124.7-.6l121.5.2 5.3 2.9z"}}),_c('path',{attrs:{"d":"M171.9 153c-3.4 2-4.1 6.2-2.9 16.2 4.4 36.6 29.5 65.3 65.5 75.1 11.4 3.1 32.5 3 44-.1 16-4.4 30-12.7 41.1-24.3 7.7-8.1 11.7-14 16.4-24.2 4.7-10.2 6.9-18.7 7.7-29.9.6-8.3.5-8.7-2-11.2-3.3-3.3-7.9-3.4-11.1-.3-1.9 1.9-2.4 3.7-2.9 10.7-2.7 38.8-36.5 68.1-75.7 65.7-18.9-1.2-32.9-7.5-46.5-21.2-7.4-7.3-9.9-10.6-13.2-17.5-4.8-9.8-6.9-17.3-7.9-28.3-.6-6.7-1-8.1-3.2-9.7-2.6-2.1-6.7-2.5-9.3-1z"}})])
          )
        }
      }
    